import { UUID } from '../interfaces/core';
import { GUID_REGEXP } from './guid_regexp.constant';
import { getUUIDV4 } from './get_guid_v4';

const EMPTY_GUID: UUID = '00000000-0000-0000-0000-000000000000' as UUID;

/**
 * Service of receiving GUID for sending for the rid server, is necessary on Beck for tracing of a request
 */
export class CommonGUIDService {

	// GUID regexp source string without start and end of a line
	static readonly guidRegexSource: string = GUID_REGEXP.source.slice(0, -1).substring(1);

	static isGuid (value: string): boolean {
		let result =  false;
		if (!!value) {
			const matches = value.toString().match(GUID_REGEXP);
			result = !!(matches && matches.length);
		}
		return result;
	}

	static getGUID (): UUID {
		return getUUIDV4();
	}

	static getEmptyGUID (): UUID {
		return EMPTY_GUID;
	}
}

